module.exports = __webpack_public_path__ + "static/media/word-logo.55c39d0c.png";